import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AlertComponent } from './alert/alert.component';
import { ConfirmComponent } from './confirm/confirm.component';
import { DialogService } from './dialog.service';
import { MultipleButtonComponent } from './multiple-button/multiple-button.component';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, ModalModule.forRoot()],
  declarations: [AlertComponent, ConfirmComponent, MultipleButtonComponent],
  exports: [AlertComponent, ConfirmComponent, MultipleButtonComponent],
  providers: [DialogService],
})
export class DialogModule {}
